module.exports = __webpack_public_path__ + "img/flowpath2.3f4e6f5e.png";